"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HttpCodes_1 = __importDefault(require("configs/HttpCodes"));
const baseSchema_1 = require("../../baseSchema");
class TryComentClassStatus extends baseSchema_1.BaseSchema {
    constructor({ isSuccess = true, status, statusCode = HttpCodes_1.default.OK, failureDescription = baseSchema_1.ResultType.FAILURE_DESCRIPTION, arrivedFromDropdownMenu = false, commentId, productId, userAreaId, classroomId }) {
        super();
        this.action = baseSchema_1.ActionsName[`TRY_COMMENTS_CLASS_${status}`];
        this.componentName = baseSchema_1.ComponentNames[`BUTTON_STATUS_${status}`];
        this.componentSource = !arrivedFromDropdownMenu
            ? baseSchema_1.ComponentSource.ACTION_BAR_STATUS
            : baseSchema_1.ComponentSource.DROPDOWN_STATUS;
        this.screenName = baseSchema_1.ScreenNames.PREVIEW_PENDING_COMMENT;
        this.result = isSuccess ? baseSchema_1.ResultType.SUCCESS : baseSchema_1.ResultType.FAILURE;
        this.failureDescription = failureDescription;
        this.statusCode = statusCode;
        this.commentId = commentId || undefined;
        this.productId = productId || undefined;
        this.userAreaId = userAreaId || undefined;
        this.classroomId = classroomId || undefined;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action,
            componentName: this.componentName,
            componentSource: this.componentSource,
            screenName: this.screenName,
            result: this.result,
            failureDescription: this.failureDescription,
            statusCode: this.statusCode,
            commentId: this.commentId,
            productId: this.productId,
            userAreaId: this.userAreaId,
            classroomId: this.classroomId
        };
    }
}
exports.default = TryComentClassStatus;
